<template>
  <div class="chatBox">
    <div class="chat_dom" ref="chat_dom">
      <!-- 聊天对话  -->
      <template v-for="(item, index) in chatData">
        <!-- 时间分割线（独立于气泡之外，不受 float 影响） -->
        <div
          v-if="shouldShowTime(index)"
          :key="'time-' + index"
          class="time-divider"
        >{{ item.createTime }}</div>
        <div :key="'msg-' + index" class="chat_list">
          <!-- 机器人 -->
          <div v-if="item.role === 'assistant'|| item.role === 'customer'" class="left_dom">
            <div class="left_dom_text">
              <!-- 语音消息 -->
              <div v-if="item.msgType === 2" class="voice-message" @click="playVoice(item, index)">
                <img
                  :src="require('@/image/yuyin.png')"
                  class="voice-icon"
                  :class="{ playing: playingVoiceId === (item.id || index) }"
                />
                <span class="voice-text">{{ getVoiceText(item, index) }}</span>
                <audio
                  :ref="'audio_' + (item.id || index)"
                  :src="item.content"
                  @ended="onVoiceEnded(item.id || index)"
                  style="display:none;"
                ></audio>
              </div>
              <!-- 链接消息 -->
              <p
                class="linkText"
                style="white-space: pre-wrap;"
                @click="handleLink(item)"
                v-else-if="item.msgType==3"
              >{{item.content.data}}</p>
              <!-- 文本消息 -->
              <p style="white-space: pre-wrap;" v-else>{{ item.content }}</p>
            </div>
          </div>
          <!-- 用户右 -->
          <div v-if="item.role === 'user'" class="right_dom">
            <!-- 语音消息 -->
            <div
              v-if="item.msgType === 2"
              class="voice-message voice-message--right"
              @click="playVoice(item, index)"
            >
              <span class="voice-text">{{ getVoiceText(item, index) }}</span>
              <img
                :src="require('@/image/yuyin.png')"
                class="voice-icon"
                :class="{ playing: playingVoiceId === (item.id || index) }"
              />
              <audio
                :ref="'audio_' + (item.id || index)"
                :src="item.content"
                @ended="onVoiceEnded(item.id || index)"
                style="display:none;"
              ></audio>
            </div>
            <!-- 文本消息 -->
            <div class="right_dom_text" v-else>{{ item.content }}</div>
          </div>
          <div class="clearboth"></div>
        </div>
      </template>
      <!-- 机器人输入中动画 -->
      <div v-if="isTyping" class="typing-wrapper">
        <TypingIndicator />
      </div>
    </div>
    <!-- 输入框 -->
    <div class="input_dom">
      <!-- 语音录制提示遮罩 -->
      <div v-if="recording" class="recording-mask">
        <div class="recording-icon">
          <span class="rec-dot"></span>
          <span class="rec-dot"></span>
          <span class="rec-dot"></span>
        </div>
        <p class="recording-hint">{{ recordingHint }}</p>
      </div>
      <div class="input_row">
        <!-- 模式切换按钮 -->
        <!-- <div class="mic-btn" @click="toggleInputMode">
          <img
            :src="inputMode === 'text' ? require('../../image/yuyin.png') : require('../../image/jianpan.png')"
            class="mode-icon"
          />
        </div> -->
        <!-- 文本输入模式 -->
        <template v-if="inputMode === 'text'">
          <input
            class="input"
            placeholder="请输入您的问题..."
            v-model="textarea"
            @keydown.enter="handleEnter"
          />
          <img src="../../image/send.png" alt class="sendBtn" v-if="textarea === ''" />
          <img src="../../image/send_active.png" alt class="sendBtn" @click="sendBtn" v-else />
        </template>
        <!-- 语音输入模式 -->
        <!-- <template v-else>
          <div
            class="voice-input-btn"
            :class="{ 'voice-input-btn--active': recording, 'voice-input-btn--cancel': recordingCancel }"
            @touchstart.prevent="startRecording"
            @touchend.prevent="stopRecording"
            @touchmove.prevent="handleTouchMove"
            @mousedown.prevent="startRecording"
            @mouseup.prevent="stopRecording"
            @mouseleave.prevent="cancelRecording"
          >{{ recording ? (recordingCancel ? '松开取消' : '松开发送') : '按住 说话' }}</div>
        </template> -->
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click="close">
        <div class="block" @click.stop>
          <h2>{{ item.title }}</h2>
          <br />
          <p>{{ item.content }}</p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from "vant";
import TypingIndicator from "../typingIndicator/index.vue";
import { writeFiles } from "@/services/chatAI/index.js";
export default {
  name: "ChatBox",
  components: {
    TypingIndicator
  },
  props: {
    chatData: {
      type: Array
    },
    isTyping: {
      type: Boolean,
      default: false
    },
    robotInfo: {
      type: Object
    }
  },
  data() {
    return {
      isMore: false,
      show: false,
      item: {},
      textarea: "",
      playingVoiceId: null,
      // 输入模式：'text' 文本输入 | 'voice' 语音输入
      inputMode: "text",
      // 录音相关
      recording: false,
      recordingCancel: false,
      recordingHint: "松开发送，上滑取消",
      mediaRecorder: null,
      audioChunks: [],
      recordStartTime: null,
      recordStartY: null
    };
  },
  methods: {
    handleFair() {
      this.$router.push({
        path: "/fairInfo/" + this.robotInfo?.robot_code
      });
    },
    more() {
      this.isMore = !this.isMore;
    },
    close() {
      this.show = false;
    },
    /* 发送 */
    sendBtn() {
      // console.log("textarea", this.textarea);
      if (this.textarea === "") {
        Toast("请输入内容~");
      } else {
        this.$emit("sendBtn", this.textarea);
      }
    },
    /* 键盘回车事件处理 */
    handleEnter(event) {
      if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
        console.log("换行");
      } else if (event.keyCode == 13) {
        this.sendBtn();
        event.preventDefault();
      }
    },

    /* 播放 / 暂停语音消息 */
    playVoice(item, index) {
      const key = item.id || index;
      const refKey = "audio_" + key;
      const audioRef = this.$refs[refKey];
      const audio = Array.isArray(audioRef) ? audioRef[0] : audioRef;
      if (!audio) return;

      if (this.playingVoiceId === key) {
        audio.pause();
        this.playingVoiceId = null;
        return;
      }

      // 停止其他正在播放的语音
      if (this.playingVoiceId !== null) {
        const prevRef = this.$refs["audio_" + this.playingVoiceId];
        const prevAudio = Array.isArray(prevRef) ? prevRef[0] : prevRef;
        if (prevAudio) prevAudio.pause();
      }

      this.playingVoiceId = key;
      audio.play().catch(err => {
        console.error("播放语音失败", err);
        Toast("播放语音失败");
        this.playingVoiceId = null;
      });
    },

    /* 语音播放结束 */
    onVoiceEnded(key) {
      if (this.playingVoiceId === key) {
        this.playingVoiceId = null;
      }
    },

    /* 语音气泡显示文本 */
    getVoiceText(item, index) {
      const key = item.id || index;
      if (this.playingVoiceId === key) return "播放中...";
      if (item.voiceTime) return `语音 ${item.voiceTime}"`;
      return "点击播放";
    },

    /* 判断是否显示时间分割线：与上一条消息间隔 >= 5 分钟则显示，兼容 "2026-03-26 21:01:38" 格式 */
    shouldShowTime(index) {
      const cur = this.chatData[index];
      if (!cur || !cur.createTime) return false;
      if (index === 0) return true;
      const prev = this.chatData[index - 1];
      if (!prev || !prev.createTime) return false;
      const toDate = t => new Date(String(t).replace(" ", "T"));
      const diff = toDate(cur.createTime) - toDate(prev.createTime);
      return diff >= 5 * 60 * 1000;
    },

    /* 跳转链接，仅小程序h5环境才生效 */
    handleLink(item) {
      if (item.msgType !== 3) return;
      try {
        wx.miniProgram.navigateTo({
          url: item.content.link //pages/information/information
        });
      } catch (error) {
        console.log("error", error);
        Toast("该链接已失效或仅支持在微信中打开");
      }
    },

    /* ========== 输入模式切换 ========== */
    toggleInputMode() {
      this.inputMode = this.inputMode === "text" ? "voice" : "text";
    },

    /* ========== 长按录音 ========== */
    async startRecording(e) {
      // 获取起始坐标（兼容 touch 和 mouse）
      this.recordStartX = e.touches ? e.touches[0].clientX : e.clientX;
      this.recordStartY = e.touches ? e.touches[0].clientY : e.clientY;
      this.recordingAction = "send";

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        Toast("当前浏览器不支持录音");
        return;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true
        });

        // 如果是首次授权，仅获取权限但不开始录音
        if (!this.microphoneGranted) {
          this.microphoneGranted = true;
          // 立即释放媒体流
          stream.getTracks().forEach(t => t.stop());
          Toast("麦克风权限已开启，请再次按住说话");
          return;
        }
        this.audioChunks = [];
        this.recordStartTime = Date.now();

        const mimeType = MediaRecorder.isTypeSupported("audio/mpeg")
          ? "audio/mpeg"
          : MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
          ? "audio/webm;codecs=opus"
          : MediaRecorder.isTypeSupported("audio/webm")
          ? "audio/webm"
          : "audio/ogg";

        this.mediaRecorder = new MediaRecorder(stream, { mimeType });
        this.mediaRecorder.ondataavailable = ev => {
          if (ev.data && ev.data.size > 0) this.audioChunks.push(ev.data);
        };
        this.mediaRecorder.onstop = () => {
          stream.getTracks().forEach(t => t.stop());
        };
        this.mediaRecorder.start();
        this.recording = true;
        // 启动计时器，每100ms更新一次录音时长
        this.recordingDuration = 0;
        this.recordingTimer = setInterval(() => {
          if (this.recording) {
            const elapsed = Math.floor(
              (Date.now() - this.recordStartTime) / 1000
            );
            this.recordingDuration = elapsed;

            // 达到60秒自动停止录音
            if (elapsed >= 60) {
              Toast("录音时长已达上限");
              this.stopRecording();
            }
          }
        }, 100);
      } catch (err) {
        console.error("麦克风权限获取失败", err);
        Toast("麦克风权限获取失败，请检查浏览器设置");
        // 权限失败时，确保释放按钮
        this.recording = false;
        this.recordingAction = "send";
        this.recordingDuration = 0;
      }
    },

    handleTouchMove(e) {
      if (!this.recording) return;
      const currentY = e.touches[0].clientY;
      const diffY = this.recordStartY - currentY;
      if (diffY > 50) {
        this.recordingCancel = true;
        this.recordingHint = "松开取消发送";
      } else {
        this.recordingCancel = false;
        this.recordingHint = "松开发送，上滑取消";
      }
    },

    cancelRecording() {
      if (!this.recording) return;
      this.recordingCancel = true;
      this.stopRecording();
    },

    async stopRecording() {
      if (!this.recording || !this.mediaRecorder) return;
      this.recording = false;

      const voiceTime = Math.round((Date.now() - this.recordStartTime) / 1000);
      const shouldCancel = this.recordingCancel;

      // 等待 onstop 触发后再处理数据
      await new Promise(resolve => {
        this.mediaRecorder.addEventListener("stop", resolve, { once: true });
        this.mediaRecorder.stop();
      });

      if (shouldCancel || voiceTime < 1) {
        if (voiceTime < 1) Toast("录音时间太短");
        this.audioChunks = [];
        this.recordingCancel = false;
        return;
      }

      const mimeType = this.mediaRecorder.mimeType || "audio/webm";
      const audioBlob = new Blob(this.audioChunks, { type: mimeType });
      this.audioChunks = [];
      this.recordingCancel = false;

      // 上传录音
      Toast.loading({ message: "上传中...", forbidClick: true, duration: 0 });
      try {
        const result = await writeFiles(audioBlob);
        Toast.clear();
        if (result.code === 200 && result.data) {
          this.$emit("sendVoice", { url: result.data, voiceTime });
        } else {
          Toast("上传录音失败");
        }
      } catch (err) {
        Toast.clear();
        console.error("上传录音失败", err);
        Toast("上传录音失败");
      }
    }
  }
};
</script>

<style scoped lang="less">
.chatBox {
  width: 100%;
  background: #ffffff;
  position: relative;
  font-size: 14px;
  letter-spacing: 0.8px;
  height: 100%;
}

img {
  width: 30px;
  height: 30px;
  display: block;
}
/* 聊天窗口内容部分 */
.chat_dom {
  height: calc(100vh - 180px);
  // height: 88%;
  overflow-y: scroll;
  overflow-x: hidden;
  // border: 1px solid red;
  // border: 1px solid rgb(0, 0, 0);
}
// .chat_list {
// border: 1px solid rgb(0, 21, 255);
// }
.clearboth {
  clear: both;
}

.right_dom,
.left_dom {
  display: flex;
  margin: 10px;
  max-width: 90%;
  position: relative;
  > div {
    margin: 0 10px;
  }
  .icon {
    // width: 100px;
    position: absolute;
    right: 20px;
    bottom: -30px;
    display: flex;
    img {
      width: 16px;
      height: 16px;
      margin: 0 5px;
      display: block;
    }
    img:hover {
      cursor: pointer;
    }
  }
}

.right_dom {
  float: right;
}

.left_dom {
  float: left;
  // margin-bottom: 50px;
}

/* 聊天气泡 */
.left_dom_text,
.right_dom_text {
  padding: 14px 20px;
  // flex-wrap: wrap;
  line-height: 20px;
  border-radius: 20px;
  width: 100%;
  max-width: 70%;
}

.right_dom_text {
  background: #1d6aff;
  color: #ffffff;
}

.left_dom_text {
  background: #edf3ff;
  color: #161616;
  /* 知识库 */
  // .docs-box {
  //   width: 100%;
  //   max-width:240px; //TODO:找到为什么要写死的原因
  //   > div {
  //     margin: 10px 0;
  //     background-color: #ffffff;
  //     padding: 10px;
  //     border-radius: 10px;
  //     color: #5e87e0;
  //   }
  //   > div:hover {
  //     cursor: pointer;
  //   }
  //   .more {
  //     text-decoration: underline;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //   }
  //   .more:hover {
  //     cursor: pointer;
  //     color: #1d6aff;
  //   }
  // }
}

/* 发送 */
.input_dom {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #f2f3f5;
  background-color: #fff;
  padding-bottom: env(safe-area-inset-bottom, 0);
  .input {
    flex: 1;
    height: 20px;
    background-color: #f1f1f1c5;
    outline: none;
    padding: 10px;
    border: none;
    border-radius: 10px;
  }
  .input:focus {
    outline: none;
  }
  .input::-webkit-input-placeholder {
    color: #c0c0c0;
  }
  .input:-moz-placeholder {
    color: #c0c0c0;
  }
  .input::-moz-placeholder {
    color: #c0c0c0;
  }
  .input:-ms-input-placeholder {
    color: #c0c0c0;
  }
}
.sendBtn {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* 弹出框 */
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 80%;
  background-color: #fff;
  border: 5px solid #6392fc;
  padding: 20px;
  border-radius: 5px;
  height: 300px;
  font-weight: 600;
  line-height: 20px;
  overflow-y: auto;
  font-size: 14px;
  height: 50%;
  overflow-y: scroll;
  p {
    color: rgba(0, 0, 0, 0.6);
  }
}

.linkText {
  color: #1d6aff;
  border-bottom: 1px dotted #1d6aff;
}
.linkText:hover {
  cursor: pointer;
}

/* 语音气泡 */
.voice-message {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  .voice-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
    transition: transform 0.2s;
    &.playing {
      animation: voice-pulse 0.8s ease-in-out infinite;
    }
  }

  .voice-text {
    font-size: 13px;
    white-space: nowrap;
  }
}

.voice-message--right {
  flex-direction: row-reverse;
  justify-content: flex-start;
  padding: 14px 20px;
  border-radius: 20px;
  background: #1d6aff;
  color: #ffffff;
  max-width: 70%;
}

@keyframes voice-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
}

/* 时间分割线 */
.time-divider {
  clear: both;
  display: flex;
  align-items: center;
  color: #999;
  font-size: 12px;
  margin: 10px 16px;
  gap: 8px;
  &::before,
  &::after {
    content: "";
    flex: 1;
  }
}

/* 输入中动画包装 */
.typing-wrapper {
  display: flex;
  margin: 10px;
  max-width: 90%;
  float: left;
  align-items: flex-start;
}

/* 输入行布局 */
.input_row {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  gap: 8px;
  position: relative;
}

/* 模式切换按钮 */
.mic-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s, transform 0.1s;
  &:active {
    background: #e0e0e0;
    transform: scale(0.95);
  }
  .mode-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}

/* 语音输入按钮（按住说话）*/
.voice-input-btn {
  flex: 1;
  height: 40px;
  background: #f1f1f1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  user-select: none;
  touch-action: none;
  transition: all 0.2s;
  &:active,
  &.voice-input-btn--active {
    background: #1d6aff;
    color: #fff;
    transform: scale(0.98);
  }
  &.voice-input-btn--cancel {
    background: #ff4d4f;
    color: #fff;
  }
}

/* 录音遮罩 */
.recording-mask {
  position: absolute;
  left: 50%;
  top: -120px;
  transform: translateX(-50%);
  width: 160px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 10;
  pointer-events: none;
}

.recording-hint {
  color: #fff;
  font-size: 12px;
  margin: 0;
  text-align: center;
}

.recording-icon {
  display: flex;
  gap: 6px;
  align-items: flex-end;
  height: 30px;
}

.rec-dot {
  display: inline-block;
  width: 6px;
  border-radius: 3px;
  background: #1d6aff;
  animation: rec-wave 1s ease-in-out infinite;
  &:nth-child(1) {
    height: 14px;
    animation-delay: 0s;
  }
  &:nth-child(2) {
    height: 22px;
    animation-delay: 0.15s;
  }
  &:nth-child(3) {
    height: 14px;
    animation-delay: 0.3s;
  }
}

@keyframes rec-wave {
  0%,
  100% {
    transform: scaleY(0.6);
    opacity: 0.7;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
}
</style>
